import { Pipe, PipeTransform } from '@angular/core';
import { Asset } from '../types';

@Pipe({
  name: 'assetNamePipe',
})
export class AssetNamePipe implements PipeTransform {
  public transform(value: Asset): string {
    if (value.type === 'trailer') {
      return `Trailer #${value.name}`;
    }
    return `Truck #${value.name}`;
  }
}
